import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { FLAG_GETTING_CITIES, GET_CITIES, CLEAR_CITIES, FLAG_CITY_ACTIVITY, GET_CITY, CLEAR_CITY } from '../types';
import { CITY_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_DELETE_CONFIG, DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG, DEFAULT_PUT_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { CITY_PATH } from '../../config/paths';
import { push } from 'react-router-redux';

const flagGettingCities = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_CITIES,
    payload: flag,
  });

const flagCityActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_CITY_ACTIVITY,
    payload: flag,
  });

const getCities = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingCities(true));
    const query = tableFilters;
    const url = `${CITY_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const cities = await response.json();
    dispatch({
      type: GET_CITIES,
      payload: cities,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingCities(false));
  }
};

const clearCities = () => (dispatch) =>
  dispatch({
    type: CLEAR_CITIES,
  });

const getCity = async ({id}) => async (dispatch) => {
  dispatch(flagCityActivity(true));
  try {
    const url = `${CITY_ENDPOINT}/${id}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const city = await response.json();
    dispatch({
      type: GET_CITY,
      payload: city,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagCityActivity(false));
  }
};

const clearCity = () => (dispatch) =>
  dispatch({
    type: CLEAR_CITY,
  });

const postCity = async ({ name, regionId }) => async (dispatch) => {
  dispatch(flagCityActivity(true));
  try {
    const payload = { name, regionId };
    const url = CITY_ENDPOINT;
    const response = await fetch(url, {
      ...DEFAULT_POST_CONFIG,
      body: JSON.stringify(payload),
    });
    await isErrorResponse(response, null, dispatch);
    await response.json();
    dispatch(push(CITY_PATH));
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagCityActivity(false));
  }
};

const deleteCity =
  async ({ cityId }) =>
  async (dispatch) => {
    try {
      dispatch(flagCityActivity(true));
      const url = `${CITY_ENDPOINT}/${cityId}`;
      const promise = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      }).then((res) => res);
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(CITY_PATH));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagCityActivity(false));
    }
  };



  const putCity =
  async ( cityId, { regionId, name }) =>
  async (dispatch) => {
    try {
      dispatch(flagCityActivity(true));
      const payload = {
        id: cityId,
        regionId,
        name,
      };
      const url = `${CITY_ENDPOINT}/${cityId}`;
      const promise = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(CITY_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagCityActivity(false));
    }
  };


export { 
  getCities, 
  clearCities, 
  postCity,
  getCity, 
  clearCity, 
  flagGettingCities,
  deleteCity,
  putCity,
};
